// i18n area 'networks' — locale ru-RU (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.ru-RU.meta.json.
import type { enUS } from './networks'

export const ruRU: typeof enUS = {
  networks: {
    common: {
      name: 'Имя',
      scope: 'Скоуп',
      operState: 'Состояние',
      actions: 'Действия',
      create: 'Создать',
      close: 'Закрыть',
      cancel: 'Отмена',
      delete: 'Удалить',
      edit: 'Изменить',
      save: 'Сохранить',
      editError: 'Не удалось изменить',
      search: 'Поиск по имени',
      empty: 'Здесь пока ничего нет',
      saveError: 'Не удалось сохранить',
      loadError: 'Не удалось загрузить — доступен ли бэкенд TVirt?',
      createError: 'Не удалось создать',
      deleteError: 'Не удалось удалить',
      deleteConfirmTitle: 'Удалить {name}?',
      deleteConfirmBody: 'Операция необратима.',
      nameHint: 'Строчные буквы, цифры и дефисы (DNS-1123)',
      up: 'Активна',
      down: 'Неактивна',
      unknown: 'Неизвестно',
      usedByVMs: 'ВМ',
      emptyTable: 'Записей нет — добавьте первую кнопкой +'
    },
    dialogTabs: {
      general: 'Общее',
      base: 'Базовое определение',
      advanced: 'Расширенная настройка',
      reserved: 'Диапазоны, зарезервированные за TVirt',
      position: 'Расположение',
      network: 'Настройка сети',
      hosts: 'Участвующие узлы'
    },
    reservedRanges: {
      note: 'Это диапазоны IP, зарезервированные за TVirt: из них он автоматически выдает адреса ВМ, контейнерам и т. д. ВНИМАНИЕ: адреса из этих диапазонов не должны использоваться вне TVirt внешними службами или устройствами.',
      from: 'От',
      to: 'До'
    },
    overlay: {
      title: 'Оверлейные сети',
      createTitle: 'Создать оверлейную сеть',
      editTitle: 'Изменить оверлейную сеть',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — назначается автоматически, если оставить пустым',
      subnet: 'Подсеть',
      subnetHint: 'CIDR оверлея — IPAM автоматически выводит из него запись реестра',
      mtu: 'MTU',
      weight: 'Вес',
      ceilMbps: 'Потолок (Мбит/с)',
      fairnessHint: 'Вес действует только при конкуренции: на свободном канале каждая сеть может использовать всю полосу. Потолок же действует всегда.',
      contention: 'Конкуренция',
      contentionTip: 'Хотя бы один узел наблюдает потери или overlimit С очередью на классе этой сети: полоса uplink оспаривается и веса действуют. Сколько и с какого момента — в сериях net.shaping.* узла.',
      firewallPolicy: 'Политика брандмауэра',
      hosts: 'Хосты',
      hostsTitle: 'Участвующие узлы',
      hostsHint: 'Каждый узел объявляет свою конечную точку в андерлее — выбор из РЕАЛЬНЫХ адресов узла, взятых из его сетевой конфигурации; необязательный адрес в оверлее должен лежать внутри подсети. Участие узла и есть ограничение размещения.',
      hostNode: 'Узел',
      hostUnderlay: 'IP андерлея',
      hostUnderlayPickNode: 'Сначала выберите узел',
      hostAddress: 'Адрес в оверлее (необязательно)',
      hostAddressOutside: 'Вне подсети overlay ({cidr})',
      addHost: 'Добавить узел',

      // Раунд #156 (стандартный диалог): наблюдаемые строки диалога деталей.
      observedAt: 'Дата наблюдения',
      attachedNics: 'Подключенные NIC'
    },
    services: {
      title: 'Сетевые службы',
      createTitle: 'Создать сетевую службу',
      editTitle: 'Изменить сетевую службу',
      kind: 'Тип',
      kindCategory: 'Службы',
      selectKindHint: 'Выберите тип службы — какой демон работает внутри, это деталь реализации, о которой TVirt заботится за вас.',
      kindLabel: {
        dhcp: 'Сервер DHCP',
        ntp: 'Сервер NTP',
        vpn: 'Сервер VPN',
        dns: 'Сервер DNS',
        gateway: 'Шлюз',
        'lb-rp': 'Балансировщик нагрузки и обратный прокси',
        floatip: 'Плавающий IP'
      },
      kindDesc: {
        dhcp: 'Выдает адреса в обслуживаемых подсетях — пулы выводятся из подсети, шлюза и зарезервированных за TVirt диапазонов сети.',
        dns: 'Авторитативный DNS для объявленных зон — записи выводятся из IPAM плюс ваши ручные.',
        gateway: 'Узел работает шлюзом для сети — NAT (DNAT, 1:1, SNAT/маскарадинг) плюс статическая маршрутизация между подключенными сетями, самовосстанавливающаяся по устройству.',
        'lb-rp': 'Балансировщик / обратный прокси перед вашими сервисами — L4 или L7 слушатели над пулами участников или над готовыми экземплярами Pod, переконфигурируемые на лету.',
        ntp: 'Служба времени для сетей — ретрансляция внешних вышестоящих серверов либо часы обслуживающего узла, отданные клиентам.',
        vpn: 'Концентратор VPN на узле — WireGuard или OpenVPN, выбирать вам: удаленный доступ для мобильных клиентов или туннель между двумя сетями.',
        floatip: 'Один адрес, который находится только на одном здоровом экземпляре App или Pod одновременно и переходит к следующей здоровой цели, когда та падает — failover без демонов; балансировка остаётся за балансировщиком.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Плавающий IP живёт в выбранной сети как ДОПОЛНИТЕЛЬНЫЙ адрес внутри пространства имён экземпляра-держателя: без портов, без балансировки, без NAT — IP клиента остаётся настоящим.',
        address: 'Плавающий IP',
        targets: 'Цели',
        targetsHint: 'В порядке ПРЕДПОЧТЕНИЯ: первая здоровая цель держит адрес. Pod означает все его экземпляры по репликам; у каждой цели свой критерий здоровья. Каждая цель должна быть подключена к той же сети.',
        targetKind: 'Цель',
        targetApp: 'Экземпляр App',
        targetPod: 'Pod (все экземпляры)',
        targetRef: 'Какой',
        health: 'Здоровье',
        healthRunning: 'Работает (каждый контейнер готов)',
        healthTcp: 'TCP-соединение',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Порт',
        path: 'Путь',
        addTarget: 'Добавить цель',
        moveUp: 'Переместить вверх',
        moveDown: 'Переместить вниз',
        preempt: 'Preempt',
        preemptHint: 'Выключено (по умолчанию): здоровый держатель сохраняет адрес, даже когда возвращается более высокая цель — без метаний. Включено: адрес всегда держит первая здоровая цель.',
        holder: 'Держатель',
        noHolder: 'нет здоровой цели',
        since: 'с',
        verdicts: 'Наблюдаемые цели',
        healthy: 'здорова',
        unhealthy: 'нездорова',
        noVerdict: 'Ещё не решено — узел-авторитет запишет первый вердикт на следующем проходе.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Этот экземпляр держит плавающий IP {address} сервиса {service}'
      },
      poolSource: 'Эндпоинты',
      poolSourceMembers: 'Статические участники',
      poolSourcePod: 'Готовые экземпляры Pod',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Порт',
      poolBackendHint: 'Эндпоинты следуют за Pod: экземпляр входит, когда работает с каждым готовым контейнером, и сразу выходит при уменьшении или смерти. Активная проверка включена по умолчанию.',
      poolBackendCount: 'готовые экземпляры Pod {pod} на порту {port}',
      node: 'Узел',
      enabled: 'Включена',
      parked: 'Припаркована',
      subnets: 'Подсети',
      subnetsHint: 'Подсети IPAM, обслуживаемые этим экземпляром — пулы выводятся из CIDR, шлюза и зарезервированных за TVirt диапазонов',
      noSubnets: 'Подсетей IPAM нет — объявите сначала логическую сеть фабрики (или подсеть оверлея): IPAM выводится из них',
      iface: 'Интерфейс прослушивания',
      ifaceHint: 'Интерфейс хоста, на котором служба открывает свой сокет (например, мост) — обязателен: сетевая служба самодостаточна, «все интерфейсы» больше не существует',
      dns: 'Сервер DNS',
      domain: 'Домен',
      detail: 'Обслуживает',
      subnetCount: 'подсетей: {n}',
      zones: 'Зоны',
      zonesHint: 'Только авторитативно — демон никогда не идет рекурсивно. Записи A выводятся из объявленных адресов узлов в указанных подсетях IPAM; переключатель обратной зоны заодно включает обслуживание соответствующих зон in-addr.arpa (PTR). Одну зону обслуживает не более одного экземпляра DNS во всем парке. Необязательный сервер имен — это FQDN, который попадает в записи NS/SOA вместо стандартного ns.<зона>; если он лежит внутри зоны, его запись A все равно выводится из обслуживающего узла.',
      zoneName: 'Имя зоны',
      zoneNs: 'Сервер имен (NS)',
      zoneSubnets: 'Подсети IPAM',
      zoneReverse: 'Обратная зона (PTR)',
      zoneRecords: 'Ручные записи',
      zoneRecordsHint: 'По одной в строке: имя ТИП значение — типы A, CNAME, MX, TXT. При совпадении имен ручная запись побеждает выведенную.',
      addZone: 'Добавить зону',

      // lb-rp (основание волны 3): слушатели на встроенных пулах — без
      // отдельного движка, перенастраиваются на лету.
      lbListeningHint: 'Экземпляр объявляет ОДНУ сеть прослушивания и ОДИН адрес — каждый слушатель привязывает его на своём порту; второй адрес — это вторая служба.',
      listeners: 'Слушатели',
      listenersHint: 'Каждый слушатель привязывает адрес экземпляра на своём порту в режиме L4 (TCP passthrough — байты никогда не открываются) или L7 (HTTP) и перенаправляет в один из пулов ниже. Пару адрес/порт обслуживает не более одного экземпляра на узел. Изменения применяются на лету — без перезапуска, без потерянных соединений.',
      listenerName: 'Имя',
      listenerMode: 'Режим',
      modeL7: 'L7 — обратный прокси HTTP',
      modeL4: 'L4 — сквозной TCP',
      listenerPort: 'Порт',
      listenerPool: 'Пул',
      addListener: 'Добавить слушателя',
      pools: 'Пулы',
      poolsHint: 'Бэкенды, на которые приземляется трафик: статические участники, балансируемые по кругу или по наименьшей загрузке, с необязательной активной проверкой работоспособности, которая выводит нездоровых участников из ротации.',
      poolName: 'Имя',
      poolAlgorithm: 'Алгоритм',
      algoRoundRobin: 'По кругу',
      algoLeastRequest: 'Наименее загруженный',
      poolCheck: 'Проверка работоспособности',
      checkNone: 'Нет',
      checkTcp: 'Соединение TCP',
      checkHttp: 'HTTP',
      poolCheckPath: 'Путь пробы',
      poolInterval: 'Интервал (с)',
      poolMembers: 'Участники',
      poolMembersHint: 'По одному в строке: адрес:порт, при желании с весом (1-128) — например, 10.0.0.21:8080 2',
      addPool: 'Добавить пул',
      memberCount: 'участников: {n}',

      // ntp (раунд ntp — ратификация 2026-08-03, последний kind семейства):
      // режим человеческими словами, список вышестоящих серверов только там,
      // где он что-то значит, подключение к сети повторяет метки шлюза.
      listen: {
        assignment: 'Назначение',
        assignmentStatic: 'Статический адрес',
        assignmentAuto: 'Автоматически (зарезервированные диапазоны TVirt)',
        autoHint: 'TVirt извлекает адрес из зарезервированных диапазонов логической сети и держит его sticky — никогда не вытягивается заново при правке или failover.',
        title: 'Слушатели',
        hint: 'Сетевая служба самодостаточна: каждый слушатель объявляет свою сеть (overlay, логическую сеть fabric или сырой интерфейс) и адрес внутри её подсети — один слушатель на адрес, wildcard больше не существует. DNS и NTP могут слушать в нескольких сетях и на нескольких адресах этих сетей.',
        address: 'Адрес прослушивания',
        add: 'Добавить слушателя'
      },
      ntp: {
        mode: 'Режим синхронизации',
        modeRelay: 'Ретрансляция внешних серверов',
        modeNodeClock: 'Часы узла',
        modeHint: 'Ретрансляция отдает время, взятое с объявленных вышестоящих серверов; режим часов узла отдает время обслуживающего узла — которое кластер и так держит синхронным',
        servers: 'Вышестоящие серверы',
        serversHint: 'Через запятую — имя хоста или IP-адрес; служба берет время отсюда и отдает его в сеть',
        port: 'Порт прослушивания',
        listening: 'Слушает на'
      },

      vpn: {
        engine: 'Движок',
        engineHint: 'Выбираете вы, и дальше он не меняется: WireGuard современный, быстрый и живет в ядре; OpenVPN — ветеран совместимости (TCP, недружелюбные сети)',
        engineLocked: 'Движок неизменяем — другой движок означает новую службу, ключи и сертификаты не переносятся',
        mode: 'Режим',
        modeRemote: 'Удаленный доступ',
        modeSite: 'Между площадками',
        modeHint: 'Удаленный доступ дает мобильным клиентам адрес внутри туннеля; режим между площадками соединяет две сети',
        port: 'Порт прослушивания',
        protocol: 'Транспорт',
        protocolWireguardHint: 'WireGuard говорит только по UDP',
        tunnelSubnet: 'Подсеть туннеля',
        tunnelSubnetHint: 'Сеть, в которой живут клиенты — записывается в реестр IPAM, рождается и умирает вместе с этой службой',
        dnsServers: 'DNS, отдаваемые клиентам',
        routes: 'Маршруты, отдаваемые клиентам',
        routesHint: 'Сети через запятую, достижимые в туннеле; подсеть туннеля включена всегда',
        peers: 'Пиры',
        peersHint: 'Оставьте открытый ключ пустым — TVirt сгенерирует пару и отдаст ее вместе с профилем. Вставьте ключ — и пир останется со своим.',
        clients: 'Клиенты',
        clientsHint: 'Каждый клиент получает сертификат, выпущенный центром сертификации этой службы. Удаление клиента ОТЗЫВАЕТ его: список отзыва перевыпускается сразу.',
        peerName: 'Имя',
        publicKey: 'Открытый ключ',
        publicKeyMinted: 'Его создает TVirt',
        peerAddress: 'Адрес в туннеле',
        peerAddressHint: 'Пусто = назначается автоматически',
        allowedIps: 'Удаленные подсети',
        allowedIpsHint: 'Через запятую, маршрутизируются через этого пира',
        endpoint: 'Конечная точка',
        presharedKey: 'Общий предварительный ключ',
        keepalive: 'Keepalive (с)',
        addPeer: 'Добавить пира',
        addClient: 'Добавить клиента',
        auth: 'Аутентификация',
        authTls: 'Сертификаты (TLS)',
        remote: 'Удаленная конечная точка',
        remoteHint: 'хост:порт удаленной стороны — пусто означает, что эта сторона ждет',
        peerRoutes: 'Удаленные подсети',
        serverPublicKey: 'Открытый ключ этого сервера',
        ca: 'Центр сертификации',
        listening: 'Слушает на',
        tunnel: 'Туннель',
        peerCount: 'пиров: {n}',
        download: 'Скачать профиль',
        downloadError: 'Не удалось экспортировать профиль',
        lastHandshake: 'Последнее рукопожатие',
        never: 'никогда',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Подключен',
        idle: 'Простаивает'
      },

      // Шлюз (волна 3 — родился как nat, ратификация 2026-08-01/02;
      // переименован и расширен 2026-08-03): три семейства правил NAT плюс
      // статические маршруты на сети прослушивания. Поддержана каждая
      // ратифицированная форма.
      gateway: {
        attach: 'Тип сети прослушивания',
        attachOverlay: 'Оверлейная сеть',
        attachNetwork: 'Логическая сеть фабрики',
        attachInterface: 'Неуправляемый интерфейс',
        overlay: 'Оверлейная сеть',
        network: 'Логическая сеть',
        interface: 'Имя интерфейса',
        interfaceHint: 'Интерфейс хоста, которым TVirt не управляет — адрес принимается как есть',
        address: 'Адрес прослушивания (шлюз)',
        addressHint: 'Адрес шлюза, на который смотрят клиенты — внутри подсети сети прослушивания',
        dnatTitle: 'Правила DNAT',
        dnatHint: 'NAT назначения: подходящий под условие трафик перенаправляется на новый адрес (и при желании на новый порт). Любой протокол из списка — порты там, где протокол их поддерживает.',
        snatTitle: 'Правила SNAT',
        snatHint: 'NAT источника: подходящий под условие трафик уходит с переписанным источником — новым явным адресом (и при желании новым портом) либо маскарадингом по адресу выхода, если оставить пустым.',
        oneToOneTitle: 'Правила 1:1 NAT',
        oneToOneHint: 'Каждый пакет на внешний адрес отображается на внутренний, а внутренний хост выходит наружу под внешним — все протоколы, оба направления.',
        external: 'Внешний адрес',
        internal: 'Внутренний адрес',
        addOneToOne: 'Добавить правило 1:1',
        family: 'Семейство',
        protocol: 'Протокол',
        source: 'Источник (адрес/подсеть)',
        destination: 'Назначение (адрес/подсеть)',
        invert: 'NOT',
        srcPorts: 'Порты источника',
        dstPorts: 'Порты назнач.',
        dstPortsHint: 'Порт или диапазон (80, 8000-8099)',
        toAddress: 'Новый адрес',
        toPort: 'Новый порт',
        snatTo: 'Новый источник (пусто = маскарадинг)',
        snatToHint: 'Явный адрес источника; пусто = маскарадинг по адресу выхода',
        addDnat: 'Добавить правило DNAT',
        addSnat: 'Добавить правило SNAT',
        routesTitle: 'Статические маршруты',
        routesHint: 'Узел маршрутизирует между сетями, к которым подключен (IP-форвардинг включен); эти маршруты добавляют достижимость сверх того — чистое ядро, динамическая маршрутизация придет в одном из следующих раундов.',
        routeDestination: 'Подсеть назначения',
        routeGateway: 'Следующий переход',
        routeMetric: 'Метрика',
        addRoute: 'Добавить маршрут',
        listening: 'Слушает на',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} маршрутов'
      },
      unknownSince: 'Неизвестно — последний отчет {m} мин назад',
      lastWord: 'Последнее слово',

      // Раунд #156 (стандартный диалог): наблюдаемые строки и сводка блока
      // kind в диалоге деталей, только для чтения.
      reportObservedAt: 'Последний отчет',
      lastErrorRow: 'Последняя ошибка',
      recordsCount: 'ручных записей: {n}',
      phase: {
        configured: 'Настроена',
        running: 'Работает',
        error: 'Ошибка'
      },
      authorityNode: 'Ответственный узел (назначение)',
      preferredNode: 'Предпочитаемый узел',
      preferredNodeHint: 'Мягкое предпочтение, никогда не ограничение: при следующем решении о размещении экземпляр приземляется здесь, если этот участник подходит — само по себе оно ничего не переносит; ход — это «Передать ответственность».',
      noPreference: 'Без предпочтения (автоматическое размещение)',
      moving: 'В движении',
      movingTooltip: 'Наблюдается здесь, пока ответственным назначается {node}: перенос сходится.',
      placement: {
        title: 'Размещение',
        loading: 'Идёт перепись…',
        loadError: 'Перепись размещения не ответила — повторите позже.',
        draftHint: 'Перепись вычисляется из объявленного подключения сети: она появится, как только служба будет создана. Создание отклоняется, когда ни один участник не может её обслуживать, и отказ называет механизм, опустошивший множество.',
        eligibleCount: '{n} из {m} участников могут обслуживать этот экземпляр',
        recommended: 'Рекомендуется',
        eligible: 'Подходит',
        notEligible: 'Не подходит',
        blockedReachability: 'сеть не доходит до этого участника',
        blockedRequireTag: 'заблокирован обязательным тегом (requireNodes)',
        blockedExcluded: 'исключён симуляцией',
        preferenceUnknown: 'не является (больше) участником кластера',
        preferenceIgnored: 'Предпочтение «{node}» сегодня не подходит: {reason}. Верх берёт рекомендация переписи — никогда не ошибка, служба живёт в другом месте.',
        emptyReachability: 'Ни один участник не может обслуживать этот экземпляр: сеть не доходит никуда — никакая правка тегов не поможет. Подключите узел кабелем или перенесите службу туда, где сеть есть.',
        emptyRequireTag: 'Ни один участник не может обслуживать этот экземпляр: множество опустошили обязательные теги — уберите запись из requireNodes или присвойте тег участнику.',
        spof: 'Единая точка отказа',
        spofDetail: 'Приютить экземпляр может ровно один участник: при отказе аварийному переключению некуда идти. Служба с несколькими слушателями переезжает как ЕДИНОЕ ЦЕЛОЕ — кандидат должен видеть ВСЕ её сети: такова цена.',
        whatIf: 'Симулировать отсутствие участников',
        whatIfHint: 'Вопрос «что, если» освобождения узла: спросите ДО эвакуации, а не узнавайте это при аварийном переключении.',
        survives: 'Без {nodes} у службы всё ещё есть дом.',
        notSurvives: 'Эвакуация {nodes} оставляет эту службу НЕРАБОТАЮЩЕЙ: производное ограничение побеждает доступность (R30) — демон, живой там, куда сеть не доходит, никому не служит и никого не тревожит.',
        transfer: 'Передать ответственность',
        transferError: 'Передача не удалась',
        transferTarget: 'Целевой участник',
        transferHint: 'Предлагаются только подходящие участники — предпочтение внутри допустимого множества, никогда не переопределение. Никакой задачи: следующий проход воркеров И ЕСТЬ перенос (старый узел пожинает, новый воплощает).'
      }
    },
    fabric: {
      tabDerivation: 'Деривация',
      importNetwork: 'Импортировать из другого fabric',
      importTitle: 'Импортировать логическую сеть',
      importHint: 'Импорт — это явное присоединение: сеть остаётся у владельца (та же идентичность, тот же stem, тот же bridge tvf-<stem>), и отсюда она мапится на порты/LAGG этого fabric — мапить ЗНАЧИТ утверждать, что доставка выходит в тот же домен L2, что и у владельца.',
      importPick: 'Сеть владельца',
      importNone: 'Нечего импортировать: у других fabric нет собственной сети, которую этот fabric ещё не знает',
      importedNetworksTitle: 'Импортированные сети',
      noImported: 'Нет импортированных сетей',
      importedFrom: 'импортирована из {fabric}',
      importedBy: 'Импортировали: {list}',
      importedCount: '+{n} импортированных',
      owner: 'Владелец',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Убрать импорт',
      unimportConfirm: 'Убрать импорт сети {name} (владелец {fabric}) из этого fabric? Отклоняется, пока порт или LAGG этого fabric её мапит, либо гость, App или сервис обслуживаются только через эту ногу.',
      unimportRefused: 'Импорт ещё используется — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Этот узел уже получает эту сеть из другого fabric, членом которого он является: узел берёт общую сеть только ОДНОЙ из своих ног (два аплинка одного L2 в bridge без STP — это петля). Снимите маппинг на портах или LAGG одного из двух fabric.',
          otherFabricDerived: 'Документ несёт блок fabric, к которому узел больше не объявляет кабель: сначала примените план того fabric (он предлагает удалить его устройства) или заберите их через take-ownership, если fabric больше нет.'
        },
        hint: 'План деривации O.3: для каждого закаблированного узла состояние, diff производное-vs-текущее, ОБЪЯВЛЕННАЯ топология бондов, dual-stack-флипы и структурированные отказы/предупреждения. Только чтение до ЯВНОГО apply — ничто никогда не приземляется на узел само.',
        refresh: 'Перезагрузить план',
        empty: 'Ни один узел не закаблирован к этой fabric (и ни один больше не несёт её блок).',
        refusal: 'Отказ',
        warning: 'Предупреждение',
        generation: 'поколение документа {n}',
        state: {
          manual: 'Ручной',
          derived: 'Производный',
          diverged: 'Разошедшийся'
        },
        topologyTitle: 'Объявленная топология',
        members: 'члены',
        primary: 'первичный',
        held: 'удержан на ОДНОМ члене',
        form: {
          perNetworkBond: 'Бонд на сеть',
          singleBond: 'Единый резервный бонд',
          laggBond: 'LACP-бонд (LAGG)',
          singlePort: 'Одиночный порт'
        },
        colAction: 'Действие',
        colKind: 'Вид',
        colDevice: 'Device',
        colDetail: 'Деталь',
        action: {
          add: 'добавить',
          remove: 'убрать',
          replace: 'заменить'
        },
        diffEmpty: 'Нет ожидающего diff — применённый документ совпадает с рендером.',
        diffBlocked: 'Нет diff: отказы выше блокируют этот узел.',
        phasePlanned: 'запланировано (шаг 1 из 3)',
        phaseDraining: 'осушается (шаг 2 из 3)',
        probeUnobserved: 'Зонд осушения: никогда не сообщался — пустота НЕИЗВЕСТНА (retire сейчас был бы отклонён).',
        probeFailed: 'Зонд осушения: наблюдение ПРОВАЛИЛОСЬ — известные метки времени переносятся, никогда «пусто», которое никто не измерил.',
        probeActive: {
          one: 'Зонд: {n} установленное соединение всё ещё на старом адресе',
          few: 'Зонд: {n} установленных соединения всё ещё на старом адресе',
          many: 'Зонд: {n} установленных соединений всё ещё на старом адресе',
          other: 'Зонд: {n} установленного соединения всё ещё на старом адресе'
        },
        probeLastActive: 'последняя активность {time}',
        probeEmpty: {
          one: 'Зонд: пусто {n} минуту',
          few: 'Зонд: пусто {n} минуты',
          many: 'Зонд: пусто {n} минут',
          other: 'Зонд: пусто {n} минуты'
        },
        probeEmptyUnknown: 'Зонд: пусто (с какого момента — неизвестно).',
        impact: '{nics} vNIC и {apps} App на этом узле используют эти сети: {list}',
        apply: 'Применить на этом узле',
        applyTitle: 'Применить деривацию — {node}',
        applyIntro: 'Производная конфигурация переписывает сетевой документ узла {node} ({n} изменений) через ту же дверь, что и редактор host-network — включая checkpoint NetworkManager и честный зонд. Предупреждения плана ниже едут вместе с актом: прочтите их перед подтверждением.',
        applyError: 'Apply не удался',
        applyRefused: 'Узел отказал:',
        planMoved: 'Fabric изменилась после этого предпросмотра — НИЧЕГО не было применено. План перезагружен: посмотрите снова и повторите.',
        retire: 'Вывести',
        retireTitle: 'Точка невозврата — вывод {address}',
        restore: 'Восстановить',
        restoreTip: 'Назад к снимку до apply (поколение {previous}) — отмена на один шаг (H13)',
        restoreTitle: 'Восстановить предыдущий документ — {node}',
        restoreIntro: 'Сетевой документ узла {node} возвращается к снимку, сделанному перед последним apply (поколение {previous}), переписанному как поколение {next} вместо {current}. Worker сводит его как любой другой документ.',
        restoreRedo: 'Заменённый документ становится новым снимком: повторное восстановление — это redo.',
        restoreClosesChain: 'Снимок — это ручной документ до деривации: цепочка закрывается здесь — дальнейшей отмены нет, узел остаётся ручным до следующего apply.',
        restoreConfirm: 'Восстановить',
        restoreError: 'Восстановление не удалось',
        retireIntro: 'Это окончательно убирает {address} ({network}) с {point}. После этого акта путь назад — ОБРАТНЫЙ флип: заново объявить старый адрес через тот же движок — никогда слепое восстановление.',
        retireOld: 'Старый адрес (убран)',
        retireNew: 'Новый адрес (остаётся)',
        retireEmptyFact: 'Зонд осушения сообщает адрес пустым: этот вывод не рвёт ни одного наблюдаемого соединения.',
        retireConfirm: 'Вывести адрес',
        severActiveLoss: {
          one: 'Оборвать {n} установленное соединение всё ещё на старом адресе — оно умирает с этим актом',
          few: 'Оборвать {n} установленных соединения всё ещё на старом адресе — они умирают с этим актом',
          many: 'Оборвать {n} установленных соединений всё ещё на старом адресе — они умирают с этим актом',
          other: 'Оборвать {n} установленного соединения всё ещё на старом адресе — они умирают с этим актом'
        },
        severUnknownLoss: 'Принять НЕИЗВЕСТНОЕ: зонд никогда не наблюдал этот адрес (или наблюдение проваливается) — живые соединения могут быть оборваны.'
      },
      title: 'Фабрика',
      createTitle: 'Создать фабрику',
      networks: 'Сети',
      switches: 'Коммутаторы',
      ports: 'Порты',
      laggs: 'LAGG',
      subnets: 'Подсети',
      tabOverview: 'Обзор',
      tabNetworks: 'Логические сети',
      tabSwitches: 'Коммутаторы',
      overviewHint: 'Фабрика с одного взгляда: каждая логическая сеть с MTU и подсетью (VLAN живут только в сопоставлениях на портах и LAGG — одна и та же сеть может ходить с разными тегами на разных портах). Фабрика — это реестр ВНЕШНЕЙ инфраструктуры: TVirt наблюдает и объявляет, никогда ничего не выделяет и трогает только те NIC, что зарегистрированы под его управлением.',
      absorptionHint: 'Каждая объявленная здесь подсеть той же записью ВЫВОДИТ свою запись в реестре IPAM — она живет и умирает вместе с сетью.',
      scopeFixedHint: 'Скоуп зафиксирован в корне кластера: физическая инфраструктура по определению общая для всего кластера.',
      networksHint: 'У каждой сети обязательная MTU (по умолчанию 1500) и обязательная подсеть; объявленные здесь шлюз, серверы DNS и статические маршруты — ЕДИНСТВЕННЫЙ ИСТОЧНИК для NIC серверов, приложений и сетевых служб.',
      switchesHint: 'Ручной реестр: порт либо не используется, либо сопоставлен (нетегированный трафик и трафик по тегам VLAN на логических сетях), либо входит в LAGG — у порта-участника своих сопоставлений нет.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Обязательный — IPAM автоматически выводит из него запись реестра',
      nodeAddressing: 'Адресация узлов',
      nodeAddressingNone: 'Нет — без адреса для узла',
      nodeAddressingPool: 'Пул — один закреплённый адрес на каждый обслуживаемый узел',
      nodeAddressingHint: 'С Пул деривация фабрики назначает каждому обслуживаемому узлу адрес из диапазонов, зарезервированных для TVirt (закрепляется после назначения).',
      backing: 'Backing',
      gateway: 'Шлюз',
      ranges: 'Зарезервированные диапазоны',
      dns: 'Серверы DNS (через запятую)',
      dnsShort: 'DNS',
      singleSourceHint: 'Объявленные здесь шлюз, DNS и маршруты — единственный источник: NIC серверов, приложения и сетевые службы берут их отсюда',
      routesTitle: 'Статические маршруты',
      routeDestination: 'Назначение (CIDR)',
      routeVia: 'Через (следующий переход)',
      portUsed: 'Используется',
      vlanMappings: 'Сопоставления VLAN',
      vlanTag: 'Тег VLAN',
      vlanNetwork: 'Логическая сеть',
      nameTaken: 'Такое имя в фабрике уже занято',
      addNetwork: 'Добавить сеть',
      editNetwork: 'Изменить сеть',
      deleteNetwork: 'Убрать сеть',
      deleteNetworkConfirm: 'Убрать логическую сеть {name} из фабрики? Ее выведенная подсеть в IPAM умрет вместе с ней (действие отклоняется, пока сеть занята службой или приложением). Привязки портов и LAGG, указывающие на неё, очищаются.',
      switchName: 'Коммутатор',
      portName: 'Порт',
      positionHint: 'Физическое расположение (необязательно) — тот же словарь, что и при размещении серверов; носит чисто описательный характер',
      addSwitch: 'Добавить коммутатор',
      editSwitch: 'Изменить коммутатор',
      deleteSwitch: 'Убрать коммутатор',
      deleteSwitchConfirm: 'Убрать коммутатор {name} со всеми его портами? LAGG соответственно сузятся (и умрут, если в них останется меньше двух портов).',
      addPort: 'Добавить порт',
      editPort: 'Изменить порт',
      deletePort: 'Убрать порт',
      deletePortConfirm: 'Убрать порт {name}?',
      untagged: 'Без тега',
      tagged: 'С тегом (тег:сеть)',
      taggedShort: 'С тегом',
      portCabling: 'Кабельные подключения',
      portState: 'Состояние',
      stateUnused: 'не используется',
      stateMapped: 'сопоставлен',
      laggPortGuard: 'Порт, входящий в LAGG, меняется со стороны LAGG',
      laggsTitle: 'LAGG',
      laggsHint: 'LAGG — это два и более порта в LACP, он может проходить через разные коммутаторы (MLAG, прозрачно); входят только неиспользуемые порты, поверхность сопоставления — сам LAGG, а убранный порт снова становится неиспользуемым.',
      addLagg: 'Добавить LAGG',
      editLagg: 'Изменить LAGG',
      deleteLagg: 'Убрать LAGG',
      deleteLaggConfirm: 'Убрать LAGG {name}? Его порты-участники снова станут неиспользуемыми.',
      lacpRate: 'Частота LACP',
      laggPorts: 'Порты-участники (2+)',
      laggPortsHint: 'Входят только неиспользуемые порты — сначала освободите сопоставленный порт',
      noNetworks: 'Логических сетей не объявлено.',
      noSwitches: 'Коммутаторов не объявлено.',
      noLaggs: 'LAGG не объявлено.',
      staleConflict: 'Другой оператор изменил эту фабрику, пока ты её редактировал: сохранение отклонено, чтобы не стереть его работу. Твои изменения всё ещё здесь, нетронутые. Обновлённая фабрика уже перезагружена: подтверди ещё раз, чтобы применить их поверх, или отмени и посмотри, что изменилось.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Только выводится: каждая подсеть рождается из логической сети фабрики или из оверлея — менять ее нужно в источнике. Назначенные адреса показывают, КТО их занимает; зарезервированные за TVirt диапазоны служат пулами автоматического назначения.',
      search: 'Поиск по имени, CIDR или адресу',
      empty: 'Сетей нет — объявите логическую сеть фабрики или подсеть оверлея: IPAM выведется из них автоматически.',
      reserved: 'Диапазоны, зарезервированные за TVirt',
      address: 'Адрес',
      origin: 'Происхождение',
      origin_declared: 'объявлен',
      origin_observed: 'наблюдается',
      holder: 'Кто занимает',
      noAddresses: 'В этой подсети нет известных адресов.',
      sourceFabric: 'Фабрика',
      sourceOverlay: 'Оверлей',
      editAtSource: 'Изменить в источнике'
    },
    firewall: {
      title: 'Группы брандмауэра',
      createTitle: 'Новая группа брандмауэра',
      editTitle: 'Изменить группу брандмауэра',
      empty: 'Ни одной группы брандмауэра — создайте первую: переиспользуемый словарь правил, на который гостевые NIC ссылаются по имени.',
      nameHint: 'Буквы, цифры и внутренние . - _; имя уникально в своем скоупе (тезок в других местах различает запись /скоуп/имя)',
      description: 'Описание',
      descriptionHint: 'Одна строка замысла, показывается везде, где выбирают группу',
      enforced: 'Принудительно в скоупе',
      enforcedHint: 'Выключено: чистый словарь — правила связывают только те NIC, которые ссылаются на группу. Включено: правила связывают каждую гостевую NIC с включённым брандмауэром под скоупом группы, со ссылкой или без.',
      enforcedChip: 'Принудительная',
      enforcedChipHint: 'Правила связывают каждую гостевую NIC с включённым брандмауэром под скоупом группы, со ссылкой или без',
      enforceWarning: 'Включение принудительного применения привяжет правила к КАЖДОЙ гостевой NIC с включённым брандмауэром под {scope} при следующем согласовании, даже без явной ссылки — а внутри активной chain drop предка окончателен: уровни ниже его не переоткроют.',
      unenforceInfo: 'Без принудительного применения правила остаются только на тех NIC, которые ссылаются на группу явно.',
      rules: 'Правила',
      tabOverview: 'Обзор',
      tabRules: 'Правила',
      orderHint: 'Порядок строк И ЕСТЬ порядок вычисления внутри группы: побеждает первое совпавшее правило.',
      statefulHint: 'Stateful подразумевается: ответы на допущенный трафик проходят сами (established/related принимаются, invalid отбрасывается — их вставляет движок, вручную они не пишутся).',
      noRules: 'Правил нет — словарь еще строится: ссылаться на него можно, и это ничего не рендерит.',
      addRule: 'Добавить правило',
      direction: 'Направление',
      directionIn: 'Входящее',
      directionOut: 'Исходящее',
      action: 'Действие',
      action_accept: 'Принять',
      action_drop: 'Отбросить',
      action_reject: 'Отклонить',
      protocol: 'Протокол',
      protocolAny: 'Любой',
      ports: 'Порты',
      source: 'Источник',
      dest: 'Назначение',
      comment: 'Комментарий',
      addressHint: 'CIDR IPv4 или <фабрика>/<логическая сеть>; пусто = любая',
      moveUp: 'Передвинуть вверх',
      moveDown: 'Передвинуть вниз',
      nicFirewall: 'Брандмауэр',
      nicAntiSpoof: 'Антиспуфинг',
      nicGroups: 'Группы брандмауэра',
      nicGroupsPlaceholder: 'Выберите группу…',
      nicGroupsHint: 'Видимые группы, включая группы вышестоящих скоупов (пригодны вниз, как теги)',
      nicGroupCount: { one: '{n} группа брандмауэра', few: '{n} группы брандмауэра', many: '{n} групп брандмауэра', other: '{n} группы брандмауэра' },
      nicOff: 'Брандмауэр выключен',
      pendingRestartHint: 'Изменения брандмауэра следуют модели сохранено/применено: они ждут следующего цикла питания (PendingRestart). Группы, принудительные из вышестоящих скоупов, применяются, когда брандмауэр NIC включён.',
      appConvergeHint: 'Изменения брандмауэра применяются при следующем согласовании контейнера. Группы, принудительные из вышестоящих скоупов, применяются, когда брандмауэр включён.',
      enforcedAncestors: 'Принудительные из вышестоящих скоупов',
      enforcedAncestorsHint: 'Эта группа применяется к каждой NIC под своим скоупом с ВКЛЮЧЁННЫМ брандмауэром — переключатель является главным выключателем NIC (выключен = никакой chain вовсе, предки включительно); внутри активной chain авторитет предка окончателен: его drop ниже не переоткрывается.'
    }
  }
}
